/*
 * @Author: iRuxu
 * @Date: 2022-06-16 18:33:46
 * @LastEditTime: 2022-06-20 15:37:39
 * @Description: 拦截器
 */

import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import User from "@/utils/user";

function loadPop(msg, popType = "message") {
    switch (popType) {
        case "message":
            ElMessage({
                message: msg,
                type: "error",
            });
            break;
        case "alert":
            ElMessageBox.alert(msg, "错误");
            break;
        case "notify":
            ElNotification({
                title: "错误",
                message: msg,
                duration: 3000,
            });
            break;
        default:
            break;
    }
}

/**
 * 标准统一包装模式
 *
 * @param {*} target
 * @param {*} options
 */
function installStandardInterceptors(target, options) {
    let popType = (options && options.popType) || "message";
    target["interceptors"]["response"].use(
        function (response) {
            if (response.data.code) {
                if (!options || !options.mute) {
                    response.data.msg && loadPop(`[${response.data.code}]${response.data.msg}`, popType);
                }
                // 仅「鉴权类」错误才销毁会话并跳转登录；普通业务错误一律只提示、不登出。
                // 否则任一业务接口返回负数 code 都会误杀登录态，并与登录页的自动登录叠加成
                // 整页刷新死循环（表现为页面卡死、反复被登出）。
                const AUTH_ERR_CODES = [-1, -2, -3];
                if (AUTH_ERR_CODES.includes(response.data.code) || response.status === 401) {
                    // 节流：2s 内最多跳转一次，避免多个请求同时失败时的重复/循环跳转。
                    const lastTs = Number(sessionStorage.getItem("AUTH_REDIRECT_TS") || 0);
                    if (Date.now() - lastTs > 2000) {
                        sessionStorage.setItem("AUTH_REDIRECT_TS", Date.now());
                        User.destroy();
                        User.toLogin(null);
                    }
                }
                return Promise.reject(response);
            }
            return response;
        },
        function (err) {
            if (!options || !options.mute) {
                if (err.response && err.response.data && err.response.data.msg) {
                    loadPop(err.response.data.msg, popType);
                } else {
                    loadPop("请求异常，请稍后重试", popType);
                }
            }
            return Promise.reject(err);
        }
    );
}

export { installStandardInterceptors, loadPop };
